import http from "../http-common";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export const getAllCustomerReviews = async (pageNumber = 1, rating = "") => {
  const params = new URLSearchParams({ page: pageNumber });
  if (rating) {
    params.set("rating", rating);
  }
  return http.get(`reviews?${params.toString()}`);
};

export const getProductCustomerReviews = async (productId, pageNumber = 1) => {
  return http.get(`product-reviews/${productId}?page=${pageNumber}`);
};

export const deleteCustomerReview = async (reviewId) => {
  return Swal.fire({
    title: "Delete review?",
    text: "This action cannot be undone.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Yes, delete it",
  }).then(async (result) => {
    if (!result.isConfirmed) {
      return { cancelled: true };
    }

    try {
      const response = await http.delete("delete-review", {
        data: { id: reviewId },
      });

      if (response.data.success) {
        toast.success("Review deleted");
        return { success: true };
      }

      toast.error(response.data.message || "Failed to delete review");
      return { success: false };
    } catch (error) {
      toast.error("Failed to delete review");
      return { success: false };
    }
  });
};
